import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=2acbd29f&scoped=true&"
import script from "./MainFooter.vue?vue&type=script&lang=js&"
export * from "./MainFooter.vue?vue&type=script&lang=js&"
import style0 from "./MainFooter.vue?vue&type=style&index=0&id=2acbd29f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acbd29f",
  null
  
)

export default component.exports